module.exports = __webpack_public_path__ + "static/media/Nacharbeit.38a9f09b.svg";